const B2B_ORDER_CACHE_KEY = 'wmc_pending_orders';
const B2B_CACHE_TTL = 3600000;
let pendingOrders;

// Run on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateOrderBadges);
} else {
  hydrateOrderBadges();
}

// Mutation observer
const orderContainer = document.querySelector('.collection__products');

const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        injectBadges(pendingOrders, node);
      }
    });
  });
});

observer.observe(orderContainer, { childList: true });

async function hydrateOrderBadges() {
  if (!window.ShopifyAnalytics?.meta?.page?.customerId) return;

  const customerId = window.ShopifyAnalytics.meta.page.customerId;
  const cachedData = JSON.parse(sessionStorage.getItem(B2B_ORDER_CACHE_KEY));
  const now = new Date().getTime();

  // Uncomment this block to make "on order" badges ony visible to these three customers
  // if (customerId != '8756796850481' &&
  //     customerId != '8805684838705' &&
  //     customerId != '8756631568689'
  //   ) {
  //   return;
  // }

  if (cachedData && (now - cachedData.timestamp < B2B_CACHE_TTL) && cachedData.userId === customerId) {
    pendingOrders = cachedData.data;
  } else {
    try {
      const response = await fetch('https://stage.store-warnermusiccanada-com.nds.acquia-psi.com/b2b/pending-orders.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: customerId })
      });

      if (!response.ok) throw new Error('Network response was not ok');
      
      pendingOrders = await response.json();

      // Store with metadata
      sessionStorage.setItem(B2B_ORDER_CACHE_KEY, JSON.stringify({
        timestamp: now,
        userId: customerId,
        data: pendingOrders
      }));
    } catch (error) {
      console.error('B2B Badge Fetch Error:', error);
      return;
    }
  }

  // 3. Inject the badges into the DOM
  injectBadges(pendingOrders);
}

function injectBadges(data, scope = document) {

  // Find all elements with a data-sku attribute
  // const elements = scope.querySelectorAll('[data-sku]');
  const elements = (scope.hasAttribute && scope.hasAttribute('data-sku')) 
    ? [scope] 
    : scope.querySelectorAll('[data-sku]');

    console.log(data);

  elements.forEach(el => {
    const sku = el.getAttribute('data-sku');

    if (sku && data[sku]) {
      if (el.querySelector('.b2b-order-badge')) return;

      const badgeHtml = `<span class="b2b-order-badge">${data[sku]} on order</span>`;
      el.insertAdjacentHTML('beforeend', badgeHtml);
    }
  });
}
